import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const Link = ({ title = 'Link', ...rest }: IconProps) => {
  return (
    <BaseSvg viewBox="0 0 16 16" title={title} {...rest}>
      <g fill="currentColor" stroke="currentColor" strokeMiterlimit="10" strokeWidth="1">
        <path
          d="M12,9l1.975-2.025 c1.367-1.367,1.367-3.583,0-4.95l0,0c-1.367-1.367-3.583-1.367-4.95,0L7,4"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9,12l-2.025,1.975 c-1.367,1.367-3.583,1.367-4.95,0l0,0c-1.367-1.367-1.367-3.583,0-4.95L4,7"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line fill="none" strokeLinecap="round" strokeLinejoin="round" x1="5" x2="11" y1="11" y2="5" />
      </g>
    </BaseSvg>
  )
}

Link.displayName = 'LinkIcon'

export default Link
